<span class="px-2 h-5 rounded-full text-xs font-semibold inline-flex items-center cursor-pointer
    bg-{{color}}-100 text-{{color}}-700 hover:bg-{{color}}-500 hover:text-white">
    <span *ngIf="showDot" class="w-2 h-2 rounded-full mr-1 bg-{{dotColor || color}}-400"></span>
    <ng-content></ng-content>
</span>
